import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

const getSubInputLists = async (props: ISubInputListProps) => {
  const {data}: {data: ISubInputLists[]} = await request.get(
    `api/v2/store/serach-subinput`,
    {
      params: props,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getSubInputLists;
